import React, { Component } from 'react';
import axios from "axios";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import moment from "moment";
import formatLink from '../../utils/formatLink';
import css from './WorkOrder.module.scss';
import Alert from "../../components/Alert/Alert";
import SurveyCalendar from "../SurveyCalendar/SurveyCalendar";
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { fetchS3Photos } from '../../utils/awsHelper';
import _ from 'lodash';

/**
 * @class
 */
const WorkOrder = class extends Component {
    // ---------- class fields: ----------
    workOrderId = this.props.match.params.id;
    source = axios.CancelToken.source();
    pickfields = [];

    postReqWO = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Date__c",
            "Start_Time__c",
            "Duration__c",
            "Work_Types__c",
            "Customer_Confirmed__c",
            "Clocked_Start__c",
            "Clocked_End__c",
            "Departure_Time__c",
            "Field_Team_Pay_IDs__c",
            "Pre_Install_Safety_Form_Completed__c",
            "Foreman__c",
            "Senior_Installer__c",
            "Additional_Techs__c",
            "Fall_Protection_Used__c",
            "Ladder_Straps__c",
            "Gutter_Guard__c",
            "Harness_For_Each_Installer__c",
            "Safe_Zone__c",
            "Water__c",
            "Shade_Zone__c",
            "Survey_Type__c",
            "Is_this_an_RSS__c",
            "Will_the_customer_be_home__c",
            "What_is_the_RSS_reason__c",
            "Permission_granted_to_access_the_roof__c",
            "Scheduling_Notes__c",
            "CU_preferences_and_access_info__c",
            "Opportunity__c",
            "Opportunity__r.Contact__c",
            "Opportunity__r.Contact__r.Phone",
            "Opportunity__r.Contact__r.Preferred_Communication__c",
            "Opportunity__r.Contact__r.Spanish_Speaking__c",
            "Opportunity__r.Sales_Representative__r.Name",
            "Opportunity__r.Sales_Representative__r.Phone",
            "Opportunity__r.Sales_Representative_2__r.Name",
            "Opportunity__r.Sales_Representative_2__r.Phone",
            "Opportunity__r.Sales_Representative_3__r.Name",
            "Opportunity__r.Sales_Representative_3__r.Phone",
            "Opportunity__r.Street__c",
            "Opportunity__r.City__c",
            "Opportunity__r.State__c",
            "Opportunity__r.Zip__c",
            "Opportunity__r.Notes_for_Field__c",
            "Opportunity__r.SS_Dropbox_Link__c",
            "Opportunity__r.Jurisdiction_opp__c",
            "Opportunity__r.Jurisdiction_opp__r.Field_Notes__c",
            "Opportunity__r.Any_Code_Gates_Animals__c",
            "Opportunity__r.Safe_Harbor_Needed__c",
            "Opportunity__r.Monitoring_Portal_ID__c",
            "Opportunity__r.Monitoring_Link__c",
            "Opportunity__r.Site_Visits__c",
            "Opportunity__r.Days_to_Clawback__c",
            "Opportunity__r.Company__c",
            "Opportunity__r.Module_Type__c",
            "Opportunity__r.Ground_Mount__c",
            "Opportunity__r.Active_Site_Assessment__c",
            "Opportunity__r.Active_Site_Assessment__r.Export_Limit__c",
            "Opportunity__r.Active_Site_Assessment__r.Site_Assessment_Notes__c",
            "Opportunity__r.Active_Site_Assessment__r.Number_of_Circuits__c",
            "Opportunity__r.Active_Site_Assessment__r.Roof_Type__c",
            "Opportunity__r.Active_Site_Assessment__r.Roof_Tilt_2__c",
            "Opportunity__r.Active_Site_Assessment__r.Roof_Notes__c",
            "Opportunity__r.Active_Site_Assessment__r.Ceiling_Type__c",
            "Opportunity__r.Electrical_Work__c",
            "Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c",
            "Opportunity__r.Electrical_Work__r.Other_Electrical_Notes__c",
            "Opportunity__r.Active_Prelim_Proposal__c",
            "Opportunity__r.Active_Prelim_Proposal__r.PCS_Conductor_Limit_A__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Battery_Type__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Battery_Type__r.Name",
            "Opportunity__r.Active_Prelim_Proposal__r.Number_of_Batteries__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Inverter__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Inverter__r.Name",
            "Opportunity__r.Active_Prelim_Proposal__r.Module__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Module__r.Name",
            "Opportunity__r.Active_Prelim_Proposal__r.Conduit_Wire_on_Wall_10ft__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Structure_Levels__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Post_Panel_Count__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Number_of_Arrays__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Conduit_run_through_attic__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Pigeon_netting__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Feet_of_Trenching_Dirt__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Trenching_Concrete_Color_Match__c",
            "Opportunity__r.Active_Prelim_Proposal__r.Trenching_Concrete_No_Color_Match__c",
            "Opportunity__r.Active_Post_Proposal__c",
            "Opportunity__r.Active_Post_Proposal__r.PCS_Conductor_Limit_A__c",
            "Opportunity__r.Active_Post_Proposal__r.Battery_Type__c",
            "Opportunity__r.Active_Post_Proposal__r.Battery_Type__r.Name",
            "Opportunity__r.Active_Post_Proposal__r.Number_of_Batteries__c",
            "Opportunity__r.Active_Post_Proposal__r.Inverter__c",
            "Opportunity__r.Active_Post_Proposal__r.Inverter__r.Name",
            "Opportunity__r.Active_Post_Proposal__r.Module__c",
            "Opportunity__r.Active_Post_Proposal__r.Module__r.Name",
            "Opportunity__r.Active_Post_Proposal__r.Conduit_Wire_on_Wall_10ft__c",
            "Opportunity__r.Active_Post_Proposal__r.Structure_Levels__c",
            "Opportunity__r.Active_Post_Proposal__r.Post_Panel_Count__c",
            "Opportunity__r.Active_Post_Proposal__r.Number_of_Arrays__c",
            "Opportunity__r.Active_Post_Proposal__r.Conduit_run_through_attic__c",
            "Opportunity__r.Active_Post_Proposal__r.Pigeon_netting__c",
            "Opportunity__r.Active_Post_Proposal__r.Feet_of_Trenching_Dirt__c",
            "Opportunity__r.Active_Post_Proposal__r.Trenching_Concrete_Color_Match__c",
            "Opportunity__r.Active_Post_Proposal__r.Trenching_Concrete_No_Color_Match__c",
            "Assigned_Field_Team__c",
            "Assigned_Field_Team__r.Subcontractor__c",
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Id",
            "Assigned_Field_Team__r.Tech_1__r.Name",
            "Assigned_Field_Team__r.Tech_1__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_2__c",
            "Assigned_Field_Team__r.Tech_2__r.Id",
            "Assigned_Field_Team__r.Tech_2__r.Name",
            "Assigned_Field_Team__r.Tech_2__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_3__c",
            "Assigned_Field_Team__r.Tech_3__r.Id",
            "Assigned_Field_Team__r.Tech_3__r.Name",
            "Assigned_Field_Team__r.Tech_3__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_4__c",
            "Assigned_Field_Team__r.Tech_4__r.Id",
            "Assigned_Field_Team__r.Tech_4__r.Name",
            "Assigned_Field_Team__r.Tech_4__r.Payroll_ID__c",
            "Assigned_Field_Team__r.Tech_5__c",
            "Assigned_Field_Team__r.Tech_5__r.Id",
            "Assigned_Field_Team__r.Tech_5__r.Name",
            "Assigned_Field_Team__r.Tech_5__r.Payroll_ID__c",
            "Assigned_Field_Team_2__c",
            "Assigned_Field_Team_2__r.Tech_1__c",
            "Assigned_Field_Team_2__r.Tech_1__r.Id",
            "Assigned_Field_Team_2__r.Tech_1__r.Name",
            "Assigned_Field_Team_2__r.Tech_1__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_2__c",
            "Assigned_Field_Team_2__r.Tech_2__r.Id",
            "Assigned_Field_Team_2__r.Tech_2__r.Name",
            "Assigned_Field_Team_2__r.Tech_2__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_3__c",
            "Assigned_Field_Team_2__r.Tech_3__r.Id",
            "Assigned_Field_Team_2__r.Tech_3__r.Name",
            "Assigned_Field_Team_2__r.Tech_3__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_4__c",
            "Assigned_Field_Team_2__r.Tech_4__r.Id",
            "Assigned_Field_Team_2__r.Tech_4__r.Name",
            "Assigned_Field_Team_2__r.Tech_4__r.Payroll_ID__c",
            "Assigned_Field_Team_2__r.Tech_5__c",
            "Assigned_Field_Team_2__r.Tech_5__r.Id",
            "Assigned_Field_Team_2__r.Tech_5__r.Name",
            "Assigned_Field_Team_2__r.Tech_5__r.Payroll_ID__c",
            "Case__c",
            "Case__r.Description",
            "Case__r.RecordTypeId",
            "Case__r.ToDoListValues__c",
            "Safe_Harbor_SNs_Photos_Uploaded__c",
            "Job_Overview__c",
            "Job_Overview__r.R_Module_Safe_Harbor_SNs__c",
            "Job_Overview__r.R_Inverter_Safe_Harbor_SNs__c",
            "Job_Overview__r.R_Battery_Safe_Harbor_SNs__c",
            "Job_Overview__r.R_Racking_Safe_Harbor_SNs__c",
            "Job_Overview__r.Remaining_Work_Types__c",
            "Job_Overview__r.Scheduled_Work_Types__c",
            "Job_Overview__r.Completed_Work_Types__c",
            "Job_Overview__r.Review_Checklist_Completed__c",
            "Job_Overview__r.Skills_Required__c",
            "Job_Overview__r.Priority__c",
            "Job_Overview__r.Nearest_Hospital_Name__c",
            "Job_Overview__r.Nearest_Hospital_Address__c",
            "Job_Overview__r.Potential_Ground_Hazards__c",
            "Job_Overview__r.Potential_Roof_Hazards__c"
        ],
        "where": {
            "Id": this.workOrderId
        }
    };

    postRequestCases = () => {
        const workOrder = this.state.workOrder;

        return {
            "skip": 0,
            "fields": [
                "Id",
                "Subject",
                "RecordType.DeveloperName",
                "IsClosed",
                "Description",
                "Status"
            ],
            "where": {
                "Opportunity__c": workOrder.Opportunity__c,
                "IsClosed": false
            },
            "sort": [{"CreatedDate": "DESC"}]
        }
    }

    postRequestWifiCredentials = () => {
        const workOrder = this.state.workOrder;

        return {
            "limit": 1,
            "skip": 0,
            "fields": [
                "Id",
                "Wifi_Network__c",
                "Wifi_Password__c"
            ],
            "where": {
                "Id": workOrder.Opportunity__c
            }
        }
    }

    // ---------- state: ----------
    state = {
        showInstallInfo: false,
        showSurveyInfo: false,
        showMPUInfo: false,
        showMiscElectricalInfo: false,
        showBatteryInfo: false,
        showServiceInfo: false,
        showInspectionInfo: false,
        showPendingWorkModal: false,
        pendingWorkChecklist: [], // [{"workTypesRequiredFor":[string], "rejectionNote":string, "label":string, "fieldHelpText":string, "checked":boolean, "apiName":string}]
        pendingWorkJobSpecific: false,
        fieldJobId: '',
        workOrder: {},
        isStartJobLoading: false, // needed to lock start job while it is loading.
        isSafetyFormLoading: false,
        shouldShowAlert: false,
        shouldShowCalendar: false,
        showSafeHarborNeeded: false,
        showCustomerDetails: false,
        showElectricalRoofDetails: false,
        showJobOverviewDetails: false,
        designPermitDocs: [],
        salesReps: [],
        fieldTeam: [],
        monitorIdCopied: false, // used for ui enhasement.
        openSubconCase: {},
        openServiceCase: {},
        safetyFormOpen: false,
        safetyFormNeeded: false,
        activeProposal: {},
        showWifiInformation: false, // only pull and show wifi information if the work order is today and the user is part of the field team
        wifiNetwork: '',
        wifiPassword: ''
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postReqWO,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                const opp = data.Opportunity__r;
                const activeProposal = opp.Active_Post_Proposal__r ?? opp.Active_Prelim_Proposal__r ?? {};

                // Formatting related and formula fields
                data.FullAddress = `${opp.Street__c}, ${opp.City__c}, ${opp.State__c}  ${opp.Zip__c}`;
                data.formattedTime = moment.utc(data.Start_Time__c, "HH:mm:ssZ").format("h:mm A");
                data.formattedDepTime = moment.utc(data.Departure_Time__c, "HH:mm:ssZ").format("h:mm A");
                data.fieldNotes = opp.Notes_for_Field__c;
                data.jobsitePhotos = opp.SS_Dropbox_Link__c;
                data.jurNotes = opp.Jurisdiction_opp__r?.Field_Notes__c;
                data.MonitorPortalId = opp.Monitoring_Portal_ID__c;
                data.Phone = opp.Contact__r?.Phone;
                data.groundMount = opp.Ground_Mount__c;
                data.workTypes = data.Work_Types__c ? data.Work_Types__c.split(';') : [];
                data.Job_Overview__rNearest_Hospital_Address__c = data.Job_Overview__r.Nearest_Hospital_Address__c;
                data.Job_Overview__rNearest_Hospital_Name__c = data.Job_Overview__r.Nearest_Hospital_Name__c;
                data.Job_Overview__rPotential_Ground_Hazards__c = data.Job_Overview__r.Potential_Ground_Hazards__c;
                data.Job_Overview__rPotential_Roof_Hazards__c = data.Job_Overview__r.Potential_Roof_Hazards__c;

                // For service show the work order's Any_Code_Gates_Animals__c field, otherwise show the opportunity's Any_Code_Gates_Animals__c field.
                // Was added per Cole's request in DR-11157.
                if(data.Work_Types__c && data.Work_Types__c.includes('Service')){
                    data.cuPreferencesAndAccessInfo = data.CU_preferences_and_access_info__c;
                } else {
                    data.cuPreferencesAndAccessInfo = opp.Any_Code_Gates_Animals__c;
                }

                if(activeProposal.Post_Panel_Count__c){
                    const panel_count = activeProposal.Post_Panel_Count__c;
                    const fourArrayW = (Math.ceil(panel_count/4) * 6.42).toFixed(2);
                    data.X4_high_array__c = fourArrayW + ' x 14';
                }

                // Duration Logic to make it readable
                let hours = Math.floor(data.Duration__c / 60);
                let remainingMinutes = (data.Duration__c % 60).toFixed(2);
                if (hours > 0 && remainingMinutes > 0) {
                    data.duration = `${hours}h ${remainingMinutes}m`;
                } else if (hours > 0) {
                    data.duration = `${hours}h`;
                } else {
                    data.duration = `${remainingMinutes}m`;
                }

                // Sales rep array
                const salesReps = [];
                if (opp.Sales_Representative__r) {
                    salesReps.push(opp.Sales_Representative__r);
                }
                if (opp.Sales_Representative_2__r) {
                    salesReps.push(opp.Sales_Representative_2__r);
                }
                if (opp.Sales_Representative_3__r) {
                    salesReps.push(opp.Sales_Representative_3__r);
                }

                // Field team array
                const fieldTeam = [];
                if (data.Assigned_Field_Team__r.Tech_1__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_1__r);
                }
                if (data.Assigned_Field_Team__r.Tech_2__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_2__r);
                }
                if (data.Assigned_Field_Team__r.Tech_3__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_3__r);
                }
                if (data.Assigned_Field_Team__r.Tech_4__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_4__r);
                }
                if (data.Assigned_Field_Team__r.Tech_5__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_5__r);
                }

                if(data.Assigned_Field_Team_2__r){
                    if(data.Assigned_Field_Team_2__r.Tech_1__r) {
                        fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_1__r);
                    }
                    if(data.Assigned_Field_Team_2__r.Tech_2__r) {
                        fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_2__r);
                    }
                    if(data.Assigned_Field_Team_2__r.Tech_3__r) {
                        fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_3__r);
                    }
                    if(data.Assigned_Field_Team_2__r.Tech_4__r) {
                        fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_4__r);
                    }
                    if(data.Assigned_Field_Team_2__r.Tech_5__r) {
                        fieldTeam.push(data.Assigned_Field_Team_2__r.Tech_5__r);
                    }
                }

                this.setState({workOrder: data, salesReps, fieldTeam, activeProposal});

                // Check for work types
                if(this.state.workOrder.Work_Types__c.includes('Install')){
                    this.setState({showInstallInfo: true});

                    if(opp.Safe_Harbor_Needed__c){
                        this.setState({showSafeHarborNeeded : true});
                    }
                    if(!data.Assigned_Field_Team__r.Subcontractor__c){
                        this.setState({safetyFormNeeded: true});
                    }
                }
                if(this.state.workOrder.Work_Types__c.includes('Site Survey')){
                    this.setState({showSurveyInfo: true});
                }
                if(this.state.workOrder.Work_Types__c.includes('MPU')){
                    this.setState({showMPUInfo: true});
                }
                if(this.state.workOrder.Work_Types__c.includes('TOU Battery') || this.state.workOrder.Work_Types__c.includes('Backup Battery')){
                    this.setState({showBatteryInfo: true});

                    if(opp.Safe_Harbor_Needed__c){
                        this.setState({showSafeHarborNeeded : true});
                    }
                }
                if(this.state.workOrder.Work_Types__c.includes('Misc Electrical')){
                    this.setState({showMiscElectricalInfo: true});
                }
                if(this.state.workOrder.Work_Types__c.includes('Service')){
                    this.setState({showServiceInfo: true});
                }
                if(this.state.workOrder.Work_Types__c.includes('Inspection')){
                    this.setState({showInspectionInfo: true});
                }

                // Check for design documents
                this.getDocs();

                // Getting open cases for the additional information section.
                this.getOpenCases();
                this.getPickListValues();

                // Only pull and show wifi information if the work order is today and the user is part of the field team and the work order is not a site survey or inspection
                const isPartOfFieldTeam = this.state.fieldTeam.some(tech => tech.Id === this.props?.user?.apiId);
                if(isPartOfFieldTeam && moment(this.state.workOrder.Date__c, 'YYYY-MM-DD').isSame(moment(), 'day') && !this.state.workOrder.Work_Types__c?.includes('Site Survey') && !this.state.workOrder.Work_Types__c?.includes('Inspection')){
                    this.getWifiCredentials();
                }
            })
            .catch(err => console.log('POST Error:\n', err));
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getDocs = async() => {
        const keys = {};
        fetchS3Photos({
            recordId: this.state.workOrder.Opportunity__c,
            type: '006-opportunity',
            existingState: keys,
            source: this.source,
            process: 'getRepUploads'
        })
        .then(returnedFiles => {
            let docs = [];
            
            Object.keys(returnedFiles).map(doc =>{
                if(returnedFiles[doc] === 'Design Plans' || returnedFiles[doc] === 'Permit'){
                    const parts = doc.split('/');
                    const docName = parts[parts.length - 1];
                    docs.push({name: docName, key: 'https://v3-salesforce-file-storage.s3.us-west-2.amazonaws.com/' + doc});
                }
            })

            this.setState({designPermitDocs: docs});
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });
    }

    getWifiCredentials = async() => {
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestWifiCredentials(),
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({
                    wifiNetwork: data.Wifi_Network__c,
                    wifiPassword: data.Wifi_Password__c,
                    showWifiInformation: true
                });
            })
            .catch(err => console.log('GET Error Wifi Credentials:\n', err));
    }

    isStartJobDisabled = () => {
        // Either work order was not loaded or the start job is locked due to salesforce being updated.
        if(!this.state.workOrder.Id || this.state.isStartJobLoading){
            return true;
        }

        // Check if the checkboxes required for install are already marked. If yes, allow for the start job button to be available without uploading new SH SNs photos.
        if(this.state.workOrder.Work_Types__c.includes('Install') && this.state.workOrder.Opportunity__r.Safe_Harbor_Needed__c){
            const safeHarborSNsCheckboxes = ['R_Module_Safe_Harbor_SNs__c', 'R_Inverter_Safe_Harbor_SNs__c', 'R_Racking_Safe_Harbor_SNs__c'];
            let safeHarborSNsUploaded = (this.state.workOrder.Safe_Harbor_SNs_Photos_Uploaded__c != null) || safeHarborSNsCheckboxes.every((key) => Boolean(this.state.workOrder.Job_Overview__r[key]));

            if(!safeHarborSNsUploaded){
                return true;
            }
        }

        // Require pre-install safety form to be completed prior starting install.
        if(this.state.workOrder.Work_Types__c.includes('Install') && !this.state.workOrder.Assigned_Field_Team__r.Subcontractor__c && !this.state.workOrder.Pre_Install_Safety_Form_Completed__c){
            return true;
        }

        return false;
    }

    jobStartOnClick = () => {
        this.setState({isStartJobLoading: true});
        const payload = {
            Id: this.workOrderId, 
            Clocked_Start__c: moment().format('YYYY-MM-DDTHH:mm:ssZ')
        };

        // If there is no field team pay IDs -> fill it in on job start.
        if(!this.state.workOrder.Field_Team_Pay_IDs__c){
            const techs = this.state.fieldTeam;
            const payIds = techs.map(tech => tech.Payroll_ID__c).filter(Boolean); // get an array of Pay Ids from all techs on the job.

            payload.Field_Team_Pay_IDs__c = payIds.join(';');
        }

        axios.put('/sf/WorkOrder/update', payload)
        .then(() => {
            console.log('Started Work Order');
            this.props.history.push(`/workOrderForm/${this.workOrderId}`)
        })
        .catch(err => {
            console.log('PUT Error Work Order:\n', err);
            this.setState({isStartJobLoading: false})
        });
    };

    handleShouldShowCalendar = (val) => {
        this.setState({shouldShowCalendar: val});
    };

    pendingWork = () => {
        this.setState({showPendingWorkModal: true});

        let payload = {
            TypeOfLead: 'PendingWork',
            Id: this.state.workOrder.Id
        }

        if(!this.state.pendingWorkChecklist.length){ // run only if pendingWorkChecklist is empty
            axios.post('/leadPost', payload, {cancelToken: this.source.token}).then((res) => {
                const checkboxes = res.data;
                const pendingWorkChecklist = checkboxes.filter(cb => !cb.checked);
                console.log(pendingWorkChecklist);
                this.setState({pendingWorkChecklist});
            }).catch(err => {
                console.log('Error Receiving Pending Work Checkboxes :\n', err)
            })
        }
    }

    getOpenCases = () => {
        axios.post(
            '/sf/case/findNo', 
            this.postRequestCases(),
            {
                cancelToken: this.source.token
            })
        .then((res) => {
            const data = res.data.records; // cases
            let openSubconCase = {};
            let openServiceCase = {};
            
            if(data){
                data.forEach(c => {
                    // We should not have more than one open subcontracting or service case. If we do, then it is fine for the latest to be displayed.
                    if(c.RecordType.DeveloperName === 'Subcontracting_Job' && c.IsClosed === false){
                        openSubconCase = c;
                    }
                    if(c.RecordType.DeveloperName === 'Service_Call' && c.IsClosed === false){
                        openServiceCase = c;
                    }
                })
            }

            this.setState({openSubconCase, openServiceCase});
        })
        .catch(err => console.log('(GET) Error querying Cases: ', err, JSON.stringify(err)));
    };

    getPickListValues = () => {
        axios.get(
            '/sf/WorkOrder/describeField/Fall_Protection_Used__c;', // need to end with semicolumn as then it returns a map of field api name to its information.
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }


    isCompleteSafetyFormDisabled = () => {
        const workOrder = this.state.workOrder;
        
        return this.state.isSafetyFormLoading || !(
            workOrder.Job_Overview__rNearest_Hospital_Address__c && 
            workOrder.Job_Overview__rNearest_Hospital_Name__c &&  
            workOrder.Job_Overview__rPotential_Ground_Hazards__c && 
            workOrder.Job_Overview__rPotential_Roof_Hazards__c && 
            workOrder.Foreman__c && 
            workOrder.Senior_Installer__c &&
            workOrder.Fall_Protection_Used__c &&
            (workOrder.Ladder_Straps__c || workOrder.Gutter_Guard__c || workOrder.Harness_For_Each_Installer__c || workOrder.Safe_Zone__c || workOrder.Water__c || workOrder.Shade_Zone__c)
        );
    }

    completeSafetyFormOnClick = () => {
        this.setState({isSafetyFormLoading: true});
        const workOrder = this.state.workOrder;

        // Storing some of the information on job overview, so it can be reused for other install work orders for the same customer.
        const joPayload = {
            Id: workOrder.Job_Overview__c,
            Nearest_Hospital_Address__c: workOrder.Job_Overview__rNearest_Hospital_Address__c,
            Nearest_Hospital_Name__c: workOrder.Job_Overview__rNearest_Hospital_Name__c,
            Potential_Ground_Hazards__c: workOrder.Job_Overview__rPotential_Ground_Hazards__c,
            Potential_Roof_Hazards__c: workOrder.Job_Overview__rPotential_Roof_Hazards__c
        };

        // All of the unique information is being stored on work orders, so it is always selected for each install work order for the same customer.
        const woPayload = {
            Id: this.workOrderId,
            Foreman__c: workOrder.Foreman__c,
            Senior_Installer__c: workOrder.Senior_Installer__c,
            Additional_Techs__c: workOrder.Additional_Techs__c,
            Fall_Protection_Used__c: workOrder.Fall_Protection_Used__c,
            Ladder_Straps__c: workOrder.Ladder_Straps__c,
            Gutter_Guard__c: workOrder.Gutter_Guard__c,
            Harness_For_Each_Installer__c: workOrder.Harness_For_Each_Installer__c,
            Safe_Zone__c: workOrder.Safe_Zone__c,
            Water__c: workOrder.Water__c,
            Shade_Zone__c: workOrder.Shade_Zone__c
        };

        if(!workOrder.Pre_Install_Safety_Form_Completed__c){
            workOrder.Pre_Install_Safety_Form_Completed__c = moment().format('YYYY-MM-DDTHH:mm:ssZ'); // setting the work order, so the state is wo is updated and start job is unlocked.

            woPayload.Pre_Install_Safety_Form_Completed__c = workOrder.Pre_Install_Safety_Form_Completed__c;
        }

        axios.put('/sf/JobOverview/update', joPayload)
            .then(() => {
                axios.put('/sf/WorkOrder/update', woPayload)
                    .then(() => {
                        // setting work order as we need Pre_Install_Safety_Form_Completed__c to be updated.
                        this.setState({safetyFormOpen: false, isSafetyFormLoading: false, workOrder});
                    })
                    .catch(err => {
                        console.log('PUT Error Work Order:\n', err);
                        this.setState({isSafetyFormLoading: false});
                    });
            }).catch(err => {
                console.log('PUT Error Job Overview:\n', err);
                this.setState({isSafetyFormLoading: false});
            });
    }

    // Handles the type of field needing to be entered and will list out their values
    // Also handles updating the state of the field being passed so additional logic 
    // can be ran and the form be built for saving the fields to salesforce.
    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'multiPicklist':
                const selectedOptions = fieldProps?.split(';') ?? [];
                return(
                    <select onChange={(event) => this.assignMultiple(field, event.target.selectedOptions)} multiple>
                        <option value="" hidden disabled></option>
                        { fieldStateOptions.map((option) => <option key={option.value} value={option.value} selected={selectedOptions.includes(option.value)}>{option.label}</option>) }
                    </select>
                );
            case 'num':
                return(
                    <input
                        type="number"
                        value={fieldProps ? fieldProps : ''}
                        onChange={(event) => this.fieldOnChange(field, event.target.value)}
                    />
                );
            case 'text':
                return(
                    <input
                        type="text"
                        maxLength="255"
                        className="form-control"
                        value={fieldProps ? fieldProps : ''}
                        onChange={(event) => this.fieldOnChange(field, event.target.value)}
                    />
                );
            case 'checkbox':
                return(
                    <input
                        type="checkbox"
                        className="mr-2"
                        defaultChecked={fieldProps ? fieldProps : false}
                        onChange={(event) => this.fieldOnChange(field, !event.target.defaultChecked)}
                    />
                );
            case 'textarea':
                return(
                    <textarea
                        rows="5"
                        maxLength="255"
                        value={fieldProps ? fieldProps : ''}
                        onChange={(event) => this.fieldOnChange(field, event.target.value)}
                    />
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    // Handles updating the newly entered value for the work order
    // and setting state copying over the edited field
    fieldOnChange = (fieldName, value) => {
        const editFields = _.cloneDeep(this.state.workOrder);
        editFields[fieldName] = value;
        this.setState({workOrder:editFields});
    };

    assignMultiple = (fieldName, value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        const editFields = _.cloneDeep(this.state.workOrder);
        editFields[fieldName] = groupedValues;
        this.setState({workOrder:editFields});
    };

    render() {
        return (
            <div>
            {
                this.state.shouldShowCalendar ? 
                <SurveyCalendar onShouldShowCalendar={(val) => this.handleShouldShowCalendar(val)} oppId={this.state.workOrder.Opportunity__c} resurvey={true}/> 
                : 
                <div className={css.ScheduledJobDetails}>
                    <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage}</Alert>

                    <h1 className="my-0">
                        <a
                            className="text-white"
                            href={`https://v3electric.my.site.com/frontendOps/s/detail/${this.state.workOrder.Opportunity__c}`}
                        >{this.state.workOrder.Name}</a>
                    </h1>
                    <h2 className="my-0">{this.state.workOrder.Work_Types__c}</h2>

                    <h5 className={this.state.showSafeHarborNeeded ? "my-0 mt-4 text-danger font-weight-bold" : "d-none"}>
                        SAFE HARBOR NEEDED - UPLOAD SERIAL NUMBERS BEFORE STARTING JOB
                    </h5>

                    <div className="row mt-4">
                        <div className="col-12 col-sm-6">
                            <div>
                                <a
                                    className="text-primary font-weight-bold"
                                    href={`https://www.google.com/maps/search/?api=1&query=${this.state.workOrder.FullAddress}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{this.state.workOrder.FullAddress}</a>
                            </div>
                            <h4 className="mt-1">Full Address</h4>
                        </div>

                        <div className="col-12 col-sm-6">
                            <div className={this.state.workOrder.Phone? '' : 'd-none'}>
                                <div>
                                    <a className="text-primary font-weight-bold" href={`tel:${this.state.workOrder.Phone}`}>{this.state.workOrder.Phone}</a>
                                </div>
                                <h4 className="mt-1">Phone</h4>
                            </div>
                            <div className={(!this.state.workOrder.Phone) ? 'mt-3' : 'd-none'}>
                                <div className="text-danger">NO PHONE NUMBER</div>
                                <h4 className="mt-1">Phone</h4>
                            </div>
                        </div>
                    </div>

                    {/* ---------- Details Table: ---------- */}
                    <div className="mt-5">
                        <h2>Details</h2>
                        {/* ----- if site surveys: ----- */}
                        <table className={this.state.workOrder.Work_Types__c === 'Site Survey'? css.ScheduledJobDetails__Table : 'd-none'}>
                            <tbody>
                                <tr>
                                    <td>Start Date</td>
                                    <td className="font-weight-bold">{moment(this.state.workOrder.Date__c).format('MM/D/YY')}</td>
                                </tr>
                                <tr>
                                    <td>Departure Time</td>
                                    <td className="font-weight-bold">{this.state.workOrder.formattedDepTime}</td>
                                </tr>
                                <tr>
                                    <td>Start Time</td>
                                    <td className="font-weight-bold">{this.state.workOrder.formattedTime}</td>
                                </tr>
                                <tr>
                                    <td>Duration</td>
                                    <td className="font-weight-bold">{this.state.workOrder.duration}</td>
                                </tr>
                                <tr>
                                    <td>Survey Type</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Survey_Type__c ?? "---"}</td>
                                </tr>
                                <tr>
                                    <td>Structure Levels</td>
                                    <td className="font-weight-bold">{2}</td>
                                </tr>
                                <tr>
                                    <td>Ground Mount</td>
                                    <td className="font-weight-bold">{this.state.workOrder.groundMount ? "Yes" : "No"}</td>
                                </tr>
                                <tr>
                                    <td>Attic Run</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Did_the_customer_request_an_attic_run__c ? "Yes" : "No"}</td>
                                </tr>
                                <tr>
                                    <td>CU Preferences/Access Info</td>
                                    <td className="font-weight-bold">{this.state.workOrder.cuPreferencesAndAccessInfo ?? "---"}</td>
                                </tr>
                                <tr>
                                    <td>Notes for Field</td>
                                    <td className="font-weight-bold overflow-auto"><textarea rows="8" value={this.state.workOrder.fieldNotes}/></td>
                                </tr>
                                <tr>
                                    <td>Scheduling Notes</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Scheduling_Notes__c ?? "---"}</td>
                                </tr>
                                <tr>
                                    <td>Is this a RSS?</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Is_this_an_RSS__c === true ? 'Yes' : 'No'}</td>
                                </tr>
                                {
                                    this.state.workOrder.Is_this_an_RSS__c === true ?
                                    <tr>
                                        <td>RSS Reason(s)</td>
                                        <td className="font-weight-bold">{this.state.workOrder.What_is_the_RSS_reason__c?.replaceAll(';', ', ') ?? "---"}</td>
                                    </tr>
                                    :
                                    ''
                                }
                                <tr>
                                    <td>Will the Customer be Home?</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Will_the_customer_be_home__c === "Yes" ? "Yes" : "No"}</td>
                                </tr>
                                <tr>
                                    <td>Permission to access roof if not home?</td>
                                    <td className="w-50 font-weight-bold">{this.state.workOrder.Permission_granted_to_access_the_roof__c === "Yes" ? "Yes" : "No"}</td>
                                </tr>
                                <tr>
                                    <td>Job Photos Link</td>
                                    <td className="font-weight-bold">
                                        <span className={this.state.workOrder.jobsitePhotos ? '' : 'd-none'}>
                                            <a href={formatLink(this.state.workOrder.jobsitePhotos)} target="_blank" rel="noopener noreferrer">{this.state.workOrder.jobsitePhotos}</a>
                                        </span>
                                        <span className={this.state.workOrder.jobsitePhotos ? 'd-none' : ''}>LINK MISSING</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Jurisdiction Notes</td>
                                    <td className="font-weight-bold">{this.state.workOrder.jurNotes ? this.state.workOrder.jurNotes : "---"}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* ----- if NOT site surveys: ----- */}
                        <table className={
                            this.state.workOrder.Work_Types__c &&
                            this.state.workOrder.Work_Types__c !== 'Site Survey'
                                ?
                                css.ScheduledJobDetails__Table
                                :
                                'd-none'
                        }>
                            <tbody>
                                <tr>
                                    <td>Start Date</td>
                                    <td className="font-weight-bold">{moment(this.state.workOrder.Date__c).format('MM/D/YY')}</td>
                                </tr>
                                <tr>
                                    <td>Departure Time</td>
                                    <td className="font-weight-bold">{this.state.workOrder.formattedDepTime}</td>
                                </tr>
                                <tr>
                                    <td>Start Time</td>
                                    <td className="font-weight-bold">{this.state.workOrder.formattedTime}</td>
                                </tr>
                                <tr>
                                    <td>Duration</td>
                                    <td className="font-weight-bold">{this.state.workOrder.duration}</td>
                                </tr>
                                {
                                    this.state.showInstallInfo ?
                                    <>
                                    {/* <tr>
                                        <td>Number of Days</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Number_of_days__c ? this.state.workOrder.Number_of_days__c : '---'}</td>
                                    </tr> */}
                                    <tr>
                                        <td>MSP Export Limit</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.PCS_Conductor_Limit_A__c ?? "---"}</td>
                                    </tr>
                                    <tr>
                                        <td>Site Export Limit</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r.Active_Site_Assessment__c && this.state.workOrder.Opportunity__r.Active_Site_Assessment__r.Export_Limit__c ? this.state.workOrder.Opportunity__r.Active_Site_Assessment__r.Export_Limit__c : "---"}</td>
                                    </tr>
                                    </>
                                    :
                                    null
                                }
                                <tr>
                                    <td>CU Preferences/Access Info</td>
                                    <td className="font-weight-bold">{this.state.workOrder.cuPreferencesAndAccessInfo ?? "---"}</td>
                                </tr>
                                <tr>
                                    <td>Customer Confirmed</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Customer_Confirmed__c ? moment(this.state.workOrder.Customer_Confirmed__c).format('MM/D/YY') : "---"}</td>
                                </tr>
                                <tr>
                                    <td>Monitoring Portal Id</td>
                                    <td className="font-weight-bold">
                                        <span title="Click to copy" className={this.state.workOrder.MonitorPortalId ? 'cursor-pointer' : 'd-none'} 
                                            onClick={() => {
                                                navigator.clipboard.writeText(this.state.workOrder.MonitorPortalId)
                                                this.setState({ monitorIdCopied: true });
                                                setTimeout(() => { this.setState({ monitorIdCopied: false }); }, 1000); // 1 second
                                            }}
                                        > 
                                            <FontAwesomeIcon icon={faClipboard} className="mr-1 text-muted"/>
                                            {this.state.monitorIdCopied ? "Copied!" : this.state.workOrder.MonitorPortalId}
                                        </span>
                                        <span className={this.state.workOrder.MonitorPortalId ? 'd-none' : ''}>---</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Notes for Field</td>
                                    <td className="font-weight-bold overflow-auto"><textarea rows="8" value={this.state.workOrder.fieldNotes}/></td>
                                </tr>
                                {
                                    this.state.showServiceInfo ?
                                    <tr>
                                        <td>Service Case Description</td>
                                        <td className="font-weight-bold overflow-auto"><textarea rows="8" value={this.state.workOrder.Case__c ? this.state.workOrder.Case__r.Description : ''}/></td>
                                    </tr>
                                    :
                                    null
                                }
                                <tr>
                                    <td>Clocked Start</td>
                                    <td className="font-weight-bold">
                                        {this.state.workOrder.Clocked_Start__c ? moment(this.state.workOrder.Clocked_Start__c).format('MM/D/YY h:mm A') : "---"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Clocked End</td>
                                    <td className="font-weight-bold">
                                        {this.state.workOrder.Clocked_End__c ? moment(this.state.workOrder.Clocked_End__c).format('MM/D/YY h:mm A') : "---"}
                                    </td>
                                </tr>
                                {
                                    // we use a ternary expression rather than hiding/showing via CSS classes because the table bg color alters by even/odd row,
                                    // so a hidden table row will give us 2 adjacent rows with the same bg color:
                                    this.state.workOrder.Inspection_Outcome__c ?
                                        <tr>
                                            <td>Inspection Outcome</td>
                                            <td className="font-weight-bold">{this.state.workOrder.Inspection_Outcome__c ? this.state.workOrder.Inspection_Outcome__c : "---"}</td>
                                        </tr>
                                        :
                                        null
                                }
                                <tr>
                                    <td>Job Photos Link</td>
                                    <td className="font-weight-bold">
                                        <span className={this.state.workOrder.jobsitePhotos ? '' : 'd-none'}>
                                            <a href={formatLink(this.state.workOrder.jobsitePhotos)} target="_blank" rel="noopener noreferrer">{this.state.workOrder.jobsitePhotos}</a>
                                        </span>
                                        <span className={this.state.workOrder.jobsitePhotos ? 'd-none' : ''}>LINK MISSING</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Jurisdiction Notes</td>
                                    <td className="font-weight-bold">{this.state.workOrder.jurNotes ? this.state.workOrder.jurNotes : "---"}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* ---------- Sales Reps Table: ---------- */}
                    <div className='mt-5'>
                        <h2>Sales Representatives</h2>
                        <table>
                            <tbody>
                            {
                                this.state.salesReps.map((rep, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{rep.Name}</td>
                                            <td className="font-weight-bold">
                                                <span className={rep.Phone ? '' : 'd-none'}>
                                                    <a href={`tel:${rep.Phone}`}>{rep.Phone}</a>
                                                </span>
                                                <span className={rep.Phone ? 'd-none' : ''}>NO PHONE NUMBER</span>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    {/* Field Team Table */}
                    <div className='mt-5'>
                        <h2>Field Team</h2>
                        <table>
                            <tbody>
                            {
                                this.state.fieldTeam.map((tech, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{tech.Name}</td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={this.state.designPermitDocs.length !== 0  ? 'mt-5' : 'd-none'}>
                        <h2>Design Plans & Permits</h2>
                        <table>
                            <tbody>
                            {
                                this.state.designPermitDocs.map((doc, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="text-break">{doc.name}</td>
                                            <td className="font-weight-bold">
                                                <a href={doc.key} target="_blank">Link To Doc</a>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    {/* Additiona Information */}
                    <div className='mt-5'>
                        <h2 className="mb-3">
                            Additional Information
                        </h2>
                    
                        {/* Customer Details Table */}
                        <div>
                            <h2 onClick={() => this.setState({ showCustomerDetails: !this.state.showCustomerDetails })} style={{ cursor: 'pointer' }} className="mb-2">
                                <FontAwesomeIcon icon={this.state.showCustomerDetails ? faCaretDown : faCaretRight} className="mr-2"/>
                                Customer Details
                            </h2>
                            <table className={this.state.showCustomerDetails ? "mb-3" : 'd-none'}>
                                <tbody>
                                    <tr>
                                        <td>Spanish Speaking</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Contact__r?.Spanish_Speaking__c ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <td>Site Visits</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Site_Visits__c || 0}</td>
                                    </tr>
                                    <tr>
                                        <td>Days to Clawback</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Days_to_Clawback__c || 0}</td>
                                    </tr>
                                    {this.state.openServiceCase && this.state.openServiceCase.Id && (<>
                                        <tr>
                                            <td className='w-50'>Open Service Call Case Subject</td>
                                            <td className="font-weight-bold">{this.state.openServiceCase?.Subject || '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className='w-50'>Open Service Call Case Description</td>
                                            <td className="w-50 font-weight-bold overflow-auto"><textarea rows="8" value={this.state.openServiceCase?.Description || ''} disabled="true"/></td>
                                        </tr>
                                    </>)}
                                    {this.state.openSubconCase && this.state.openSubconCase.Id && (<>
                                        <tr>
                                            <td className="w-50">Open Subcontracting Case Subject</td>
                                            <td className="w-50 font-weight-bold">{this.state.openSubconCase?.Subject || '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className='w-50'>Open Subcontracting Case Status</td>
                                            <td className="w-50 font-weight-bold">{this.state.openSubconCase?.Status || '---'}</td>
                                        </tr>
                                        <tr>
                                            <td className='w-50'>Open Subcontracting Case Description</td>
                                            <td className="w-50 font-weight-bold overflow-auto"><textarea rows="8" value={this.state.openSubconCase?.Description || ''} disabled="true"/></td>
                                        </tr>
                                    </>)}
                                    <tr>
                                        <td>Financing Partner</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Company__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Monitoring Link</td>
                                        <td className="font-weight-bold">
                                            <span className={this.state.workOrder.Opportunity__r?.Monitoring_Link__c ? '' : 'd-none'}>
                                                <a href={formatLink(this.state.workOrder.Opportunity__r?.Monitoring_Link__c)} target="_blank" rel="noopener noreferrer">Link</a>
                                            </span>
                                            <span className={this.state.workOrder.Opportunity__r?.Monitoring_Link__c ? 'd-none' : ''}>---</span>
                                        </td>
                                    </tr>
                                    {this.state.showWifiInformation && (<>
                                        <tr>
                                            <td>Wifi Network</td>
                                            <td className="font-weight-bold">{this.state.wifiNetwork || '---'}</td>
                                        </tr>
                                        <tr>
                                            <td>Wifi Password</td>
                                            <td className="font-weight-bold">{this.state.wifiPassword || '---'}</td>
                                        </tr>
                                    </>)}
                                    <tr>
                                        <td>Preferred Communication</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Contact__r?.Preferred_Communication__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Site Assessment Notes</td>
                                        <td className="font-weight-bold overflow-auto"><textarea rows="8" value={this.state.workOrder.Opportunity__r?.Active_Site_Assessment__r?.Site_Assessment_Notes__c || ''} disabled="true"/></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Electrical + Roof Table */}
                        <div>
                            <h2 onClick={() => this.setState({ showElectricalRoofDetails: !this.state.showElectricalRoofDetails })} style={{ cursor: 'pointer' }} className="mb-2">
                                <FontAwesomeIcon icon={this.state.showElectricalRoofDetails ? faCaretDown : faCaretRight} className="mr-2"/>
                                Electrical + Roof
                            </h2>
                            <table className={this.state.showElectricalRoofDetails ? "mb-3" : 'd-none'}>
                                <tbody>
                                    <tr>
                                        <td>Battery Type</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Battery_Type__r?.Name || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Number of Batteries</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Number_of_Batteries__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Inverter Type</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Inverter__r?.Name || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Remaining Electrical Work</td>
                                        <td className="font-weight-bold overflow-auto"><textarea rows="4" value={this.state.workOrder.Opportunity__r?.Electrical_Work__r?.Remaining_Electrical_Work__c || ''} disabled="true"/></td>
                                    </tr>
                                    <tr>
                                        <td>Conduit + Wire on Wall</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Conduit_Wire_on_Wall_10ft__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Number of Circuits</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Active_Site_Assessment__r?.Number_of_Circuits__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Other Electrical Notes</td>
                                        <td className="font-weight-bold overflow-auto"><textarea rows="4" value={this.state.workOrder.Opportunity__r?.Electrical_Work__r?.Other_Electrical_Notes__c || ''} disabled="true"/></td>
                                    </tr>
                                    <tr>
                                        <td>Structure Levels</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Structure_Levels__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Roof Type</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Active_Site_Assessment__r?.Roof_Type__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Roof Pitch</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Active_Site_Assessment__r?.Roof_Tilt_2__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Module Type</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Module__r?.Name || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Panel Count</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Post_Panel_Count__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Number of Arrays</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Number_of_Arrays__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Conduit Run Through the Attic</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Conduit_run_through_attic__c ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <td>Pigeon Netting</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Pigeon_netting__c ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <td>Roof Notes</td>
                                        <td className="font-weight-bold overflow-auto"><textarea rows="4" value={this.state.workOrder.Opportunity__r?.Active_Site_Assessment__r?.Roof_Notes__c || ''} disabled="true"/></td>
                                    </tr>
                                    <tr>
                                        <td>Ceiling Type</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Opportunity__r?.Active_Site_Assessment__r?.Ceiling_Type__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Trenching - Dirt, grass, gravel</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Feet_of_Trenching_Dirt__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Trenching Concrete (No Color Match)</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Trenching_Concrete_No_Color_Match__c ?? '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Trenching Concrete (Color Match)</td>
                                        <td className="font-weight-bold">{this.state.activeProposal.Trenching_Concrete_Color_Match__c ?? '---'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Job Overview Table */}
                        <div>
                            <h2 onClick={() => this.setState({ showJobOverviewDetails: !this.state.showJobOverviewDetails })} style={{ cursor: 'pointer' }} className="mb-2">
                                <FontAwesomeIcon icon={this.state.showJobOverviewDetails ? faCaretDown : faCaretRight} className="mr-2"/>
                                Job Overview
                            </h2>
                            <table className={this.state.showJobOverviewDetails ? "mb-3" : 'd-none'}>
                                <tbody>
                                    <tr>
                                        <td>Remaining Work Types</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Job_Overview__r?.Remaining_Work_Types__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Scheduled Work Types</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Job_Overview__r?.Scheduled_Work_Types__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Completed Work Types</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Job_Overview__r?.Completed_Work_Types__c || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>RTR Checklist Completed</td>
                                        <td className="font-weight-bold">
                                            {this.state.workOrder.Job_Overview__r?.Review_Checklist_Completed__c ? moment(this.state.workOrder.Job_Overview__r.Review_Checklist_Completed__c).format('MM/D/YY h:mm A') : '---'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Skills Required</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Job_Overview__r?.Skills_Required__c?.replaceAll(';', ', ') || '---'}</td>
                                    </tr>
                                    <tr>
                                        <td>Priority</td>
                                        <td className="font-weight-bold">{this.state.workOrder.Job_Overview__r?.Priority__c || '---'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> 

                    {/* ---------- Start/Edit Job: ---------- */}
                    {/* prevent user button click until data has been fetched: */}
                    <div className={'mt-5'}>
                        <div className={this.state.safetyFormNeeded ? 'mb-3' : 'd-none'}>
                            <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.setState({safetyFormOpen: true})}>Pre-Install Safety Form</button>
                        </div>

                        {/* if `fieldJobId` is set, then the job has already been started:  */}
                        <div className={this.state.workOrder.Clocked_Start__c ? '' : 'd-none'}> 
                            <Link to={`/workOrderForm/${this.state.workOrder.Id}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Edit Job</button>
                            </Link>
                        </div>

                        <div className={this.state.workOrder.Clocked_Start__c !== null ? 'd-none' : ''}>
                            <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.jobStartOnClick()} disabled={this.isStartJobDisabled()}>Start Job</button>
                        </div>
                    </div>

                    {/* ---------- Photo Pack: ---------- */}
                    <div className={this.state.showInstallInfo ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/install/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Install Photo Pack</button>
                            </Link>
                        </div>
                        <div className={this.state.showBatteryInfo ? 'd-none' : 'mt-3'}>
                            <Link to={`/photoPack/electrical/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Solar Electrical Photo Pack</button>
                            </Link>
                        </div>
                        <div className={this.state.showBatteryInfo ? 'mt-3' : 'd-none'}>
                            <Link to={`/photoPack/battery/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Battery Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.showMPUInfo ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/mpu/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">MPU Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={(this.state.showBatteryInfo && !this.state.showInstallInfo) ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/battery/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Battery Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.showMiscElectricalInfo ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/miscElectrical/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Misc Electrical Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.showServiceInfo ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/serviceCall/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Service Call Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.showInspectionInfo ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/inspection/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Inspection Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    <div className={this.state.showSurveyInfo ? '' : 'd-none'}>
                        <div className='mt-3'>
                            <Link to={`/photoPack/siteSurvey/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Survey Photo Pack</button>
                            </Link>
                        </div>
                    </div>

                    {/* ---------- Pending Work: ---------- */}
                    <div className={!this.state.showSurveyInfo ? "mt-3" : "d-none"}>
                        <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.pendingWork()}>Pending Work</button>
                    </div>

                    {/* ---------- Existing Photos: ---------- */}
                    <div className="mt-3">
                        <Link to={`/existingPhotos/${this.state.workOrder.Opportunity__c}`}>
                            <button className="btn btn-primary w-100 text-md" type="button">Existing Photos</button>
                        </Link>
                    </div>

                    {/* ---------- Reschedule Site Survey: ---------- */}
                    {   this.state.workOrder.Work_Types__c === 'Site Survey' ?
                        <div className="mt-3">
                                <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.setState({shouldShowCalendar: true})}>Reschedule Site Survey</button>
                        </div>
                        :
                        ''
                    }

                </div>
            }

                {/* ---------- Pending Work Modal: ---------- */}
                <Modal
                    isOpen={this.state.showPendingWorkModal}
                    onRequestClose={() => this.setState({showPendingWorkModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            maxHeight: 'calc(70vh - 2rem)', // 20vh more than original
                            background: 'rgba(53, 53, 53)'
                        }
                    }}
                >
                    <div className="mt-3 text-center text-white">
                        <h2>Pending Work</h2>

                        {/* decreasing the size based if it is a phone */}
                        <div style={{display:"flex", justifyContent:"flex-start", padding:"6px", fontSize: window.innerWidth <= 768 ? "12px" : "16px"}}>
                            <input type="checkbox" id="forThisWorkOrder" checked={this.state.pendingWorkJobSpecific} onChange={() => this.setState({pendingWorkJobSpecific:!this.state.pendingWorkJobSpecific})} style={{marginRight:"4px"}}/>
                            
                            {/* setting margin bottom to 0 to override standard styling and allign checkbox and text */}
                            <label htmlFor="forThisWorkOrder" style={{marginBottom: "0"}}>Job Specific</label>
                        </div>

                        {/* if job specific is marked, show only the checkboxes needed for this work order */}
                        {(this.state.pendingWorkChecklist.filter(cb => !this.state.pendingWorkJobSpecific || cb.workTypesRequiredFor.some(type => this.state.workOrder.workTypes.includes(type)))).map((checkbox) => (
                            <div key={checkbox.apiName} style={{display:"flex", justifyContent:"flex-start", borderRadius:"4px",padding:"6px", fontSize: window.innerWidth <= 768 ? "12px" : "16px", textAlign: "left"}}>
                                <label style={{flex: "0 0 45%", fontWeight:"bold", marginRight:"8px", borderLeft:"2px solid #c9c9c9", paddingLeft:"8px"}}>
                                    {checkbox.label}
                                </label>

                                {/* The Rejection Note on the far right; not editable */}
                                <span style={{ marginLeft: "2px", fontStyle: "italic"}}>
                                    {checkbox.rejectionNote}
                                </span>
                            </div>
                        ))}
                        <button className="btn btn-primary" type="button" onClick={() => this.setState({showPendingWorkModal: false})}>Close</button>&nbsp;
                    </div>
                </Modal>

                {/* ---------- Tech Removal Confirmation Modal ---------- */}
                <Modal
                    isOpen={this.state.safetyFormOpen}
                    onRequestClose={() => this.setState({safetyFormOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            maxHeight: 'calc(100vh - 2rem)', // 20vh more than original
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="mt-2 text-white">
                        <h2 className="text-center">Pre-Install Safety Form</h2>

                        <div className="text-center">This form is required for completion before the start of work.</div>

                        <div className="mt-2">
                            <div className="form-group">
                                <label>Foreman*</label>
                                {this.getInput("text", "Foreman__c", this.state.workOrder.Foreman__c)}
                            </div>

                            <div className="form-group">
                                <label>Senior Installer*</label>
                                {this.getInput("text", "Senior_Installer__c", this.state.workOrder.Senior_Installer__c)}
                            </div>

                            <div className="form-group">
                                <label>Additional Techs</label>
                                {this.getInput("text", "Additional_Techs__c", this.state.workOrder.Additional_Techs__c)}
                            </div>

                            <div className="form-group">
                                <label>Type of Fall Protection Used*</label>
                                {this.getInput("multiPicklist", "Fall_Protection_Used__c", this.state.workOrder.Fall_Protection_Used__c, this.pickfields.Fall_Protection_Used__c?.picklistValues || [])}
                            </div>

                            <div className="form-group">
                                <label>Nearest Hospital Address*</label>
                                {this.getInput("text", "Job_Overview__rNearest_Hospital_Address__c", this.state.workOrder.Job_Overview__rNearest_Hospital_Address__c)}
                            </div>

                            <div className="form-group">
                                <label>Nearest Hospital Name*</label>
                                {this.getInput("text", "Job_Overview__rNearest_Hospital_Name__c", this.state.workOrder.Job_Overview__rNearest_Hospital_Name__c)}
                            </div>

                            <div className="form-group">
                                <label>Potential Roof Hazards*</label>
                                {this.getInput("textarea", "Job_Overview__rPotential_Roof_Hazards__c", this.state.workOrder.Job_Overview__rPotential_Roof_Hazards__c)}
                            </div>

                            <div className="form-group">
                                <label>Potential Ground Hazards*</label>
                                {this.getInput("textarea", "Job_Overview__rPotential_Ground_Hazards__c", this.state.workOrder.Job_Overview__rPotential_Ground_Hazards__c)}
                            </div>

                            <div className="form-group">
                                <label>Safety Checklist*</label>
                                <div>
                                    <label>
                                        {this.getInput('checkbox', 'Ladder_Straps__c', this.state.workOrder.Ladder_Straps__c)}
                                        Ladder Straps
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        {this.getInput('checkbox', 'Gutter_Guard__c', this.state.workOrder.Gutter_Guard__c)}
                                        Gutter Guard (if applicable)
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        {this.getInput('checkbox', 'Harness_For_Each_Installer__c', this.state.workOrder.Harness_For_Each_Installer__c)}
                                        Harness For Each Installer
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        {this.getInput('checkbox', 'Safe_Zone__c', this.state.workOrder.Safe_Zone__c)}
                                        Safe Zone (Caution Tape + Cones)
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        {this.getInput('checkbox', 'Water__c', this.state.workOrder.Water__c)}
                                        Water
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        {this.getInput('checkbox', 'Shade_Zone__c', this.state.workOrder.Shade_Zone__c)}
                                        Shade Zone
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="mt-4 d-flex justify-content-end align-items-center text-white">
                            <button className='btn btn-primary' type="button" onClick={() => this.completeSafetyFormOnClick()} disabled={this.isCompleteSafetyFormDisabled()}>
                                {this.state.workOrder.Pre_Install_Safety_Form_Completed__c === null ? 'Complete' : 'Save'} 
                            </button>
                            &nbsp;
                            <button className='btn btn-primary' type="button" onClick={() => this.setState({safetyFormOpen: false})}>Cancel</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};
export default connect(mapStateToProps)(WorkOrder);